if (!customElements.get('mdm-promo')) {
  customElements.define('mdm-promo', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-copy]');
      if (!this.button || !navigator.clipboard?.writeText) return;
      this.button.hidden = false;
      this.copy = async () => {
        try {
          await navigator.clipboard.writeText(this.dataset.code);
          this.querySelector('[data-status]').textContent = 'Code copied. Apply it at checkout.';
        } catch {
          this.querySelector('[data-status]').textContent = 'Copy is unavailable. Select and copy the code above.';
        }
      };
      this.button.addEventListener('click', this.copy);
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.copy);
    }
  });
}
